import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';


class SegmentCategory extends BaseApi {
	saveSegmentCategoryData(dto: any) { return this.post(`/${DMS_MODULE}/${NAME}/SaveSegmentCategory`, dto); }
	deleteSegmentCategoryData(id: any) { return this.delete(`/${DMS_MODULE}/${NAME}/DeleteSegmentCategory?Id=${id}`); }
}
export const apiProvider = new SegmentCategory(DMS_MODULE, NAME);
